import React from 'react'
import styles from "../styles/Home.module.scss";
import { isMobile } from 'react-device-detect';

const FooterSection = (props) =>{
  const { qrCode, 
    footerText, 
    desktopImg} = props;

  
  const DesktopRender = () => {
    return (
      <div className={styles.footerWrapper}>
      <div className={styles.contentFooter}>
        <div>
          <h1>{footerText.header}</h1>
        </div>
        <div className={styles.footerText}>
          <p>{footerText.text}</p>
        </div>
        <div>
          <img src={qrCode}  alt="qr code" />
        </div>
      </div>
      <div>
        {/* <img className={styles.footerImg} src={desktopImg} alt="globe community"/> */}
      </div>
      <div className={styles.bitCriteria}>
        <a href="/bit_acceptancecriteria"
          target="_blank"
          rel="noopener noreferrer">
          Bit Acceptance Criteria
        </a>
      </div>
    </div>
    )
  }

  const MobileRender = () => {
    return ( 
      <div className={styles.mobileFooterWrapper}> 
         <div className={styles.contentFooter}>
          <div>
            <h1>{footerText.header}</h1>
          </div>
          <div className={styles.footerText}>
            <p>{footerText.text}</p>
          </div>
          <div className= {styles.mobileButtons}>
            <a
                href="https://apps.apple.com/us/app/buildbox-world/id1544021219"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className={styles.appstoreBtn}
                  src="https://frontend-assets.buildbox.com/AppStoreButton.png"
                  alt="Download Buildbox World App Store"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.apponboard.bbworld"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className={styles.appstoreBtn}
                  src="https://frontend-assets.buildbox.com/GooglePlay.png"
                  alt="Buildbox World Google Play Button"
                />
              </a>  
          </div>   
          <div> 
            {/* <img className={styles.footerImg} src={desktopImg} alt="globe community"/> */}
          </div>
        </div>
        <div className={styles.bitCriteria}>
          <a href="/bit_acceptancecriteria"
            target="_blank"
            rel="noopener noreferrer">
            Bit Acceptance Criteria
          </a>
        </div>
      </div>
    )
  }
  return (
    <>
      {!isMobile && <DesktopRender/>}
      {isMobile && <MobileRender/>}
    </>
  )
}
export default FooterSection
 